import { Suspense } from 'react';

import Box from '@zenbusiness/zui/Box';
import PropTypes from 'prop-types';

import { checkIsMobile, getMobileDeviceType } from '#client/utils/devices';

import {
  ActionBoxStyled,
  ButtonStyled,
  CloseButtonStyled,
  DialogActionsStyled,
  DialogContentStyled,
  DialogStyled,
  DialogTitleStyled,
  ImageContainerStyled,
  ImageStyled,
  TitleStyled
} from './ImageViewModal.styles';
import PinchZoom from '../PinchZoom';

export default function ImageViewModal({
  title,
  okText,
  closeText,
  base64Image,
  handleClose,
  handleOK
}) {
  const deviceType = checkIsMobile() ? getMobileDeviceType() : 'desktop';

  const handleRetakeAndClose = () => {
    handleOK();
    handleClose();
  };

  const handleUsePhotoAndClose = () => {
    handleClose();
  };

  return (
    <DialogStyled
      disableRestoreFocus
      fullScreen
      onClose={handleClose}
      open
      role="dialog"
    >
      <DialogTitleStyled
        component="div"
        deviceType={deviceType}
      >
        <Box
          textAlign="center"
          width="100%"
        >
          <TitleStyled
            align="center"
            deviceType={deviceType}
            size="xl"
            weight="medium"
          >
            {title}
          </TitleStyled>
        </Box>
        <Box
          aria-label="Close modal"
          onClick={handleClose}
        >
          <CloseButtonStyled
            color="primary"
            deviceType={deviceType}
          />
        </Box>
      </DialogTitleStyled>
      <DialogContentStyled deviceType={deviceType}>
        <Suspense fallback={<div />}>
          <ImageContainerStyled deviceType={deviceType}>
            <PinchZoom centerOnInit>
              <ImageStyled
                alt={title}
                deviceType={deviceType}
                role="img"
                src={base64Image}
              />
            </PinchZoom>
          </ImageContainerStyled>
        </Suspense>
      </DialogContentStyled>
      {handleOK && (
        <DialogActionsStyled deviceType={deviceType}>
          <ActionBoxStyled deviceType={deviceType}>
            <ButtonStyled
              color="error"
              onClick={handleRetakeAndClose}
              size="large"
              variant="contained"
            >
              {okText}
            </ButtonStyled>
            <ButtonStyled
              onClick={handleUsePhotoAndClose}
              size="large"
              variant="contained"
            >
              {closeText}
            </ButtonStyled>
          </ActionBoxStyled>
        </DialogActionsStyled>
      )}
    </DialogStyled>
  );
}

ImageViewModal.propTypes = {
  title: PropTypes.string.isRequired,
  okText: PropTypes.string,
  closeText: PropTypes.string,
  base64Image: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleOK: PropTypes.func
};
